<template>
  <div>
    <v-layout class="ma-0">
      <v-spacer />
      <v-btn
        v-if="installedCrx"
        :loading="loading === 'taobao'"
        :small="small"
        round
        color="#f63b00"
        class="white--text mr-1"
        style="width: 200px;"
        @click.stop="toTaobao('taobao')"
      >
        <i
          class="iconfont icontaobao mr-1"
          style="font-size: 20px;line-height: 18px;"
        />
        設置到淘寶
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="installedCrx"
        :loading="loading === '1688'"
        :small="small"
        round
        color="#f75900"
        class="white--text"
        style="width: 200px;"
        @click.stop="toTaobao('1688')"
      >
        <i
          class="iconfont iconalibaba"
          style="font-size: 26px;line-height: 18px;"
        />
        設置到阿里巴巴
      </v-btn>
      <v-spacer />
    </v-layout>
    <div
      v-if="!installedCrx"
      class="grey lighten-4 pa-2 mt-4"
    >
      安裝
      <a
        class="down-link"
        href="https://chrome.google.com/webstore/detail/%E5%B7%A7%E5%B7%A7%E9%83%8E%E5%8C%85%E8%A3%B9%E7%AE%A1%E5%AE%B6/lacejchmbljdoaimkbmcflcechgndbim"
        target="_blank"
      >巧巧郎的鑰匙</a>
      ，地址自動key入到淘寶。
    </div>
    <v-dialog
      :value="showUpdagteAddrDialog"
      persistent
      width="500"
    >
      <v-card v-if="isUpdateAddr">
        <v-card-text>
          <div
            class="pa-2"
          >
            <div class="text-xs-center">
              <img src="./images/icon_cartoon1.png">
              <div
                class="orange--text text--darken-3 display-1 "
              >
                「收件資料需要更新」
              </div>
            </div>
            <div class="subheading orange--text text--darken-3 px-4 mt-2">
              <div class="">
                請勿驚慌~一切正常~<br>
                舊倉庫貨照收，貨照包，<br>
                您只需要立即設定新倉庫地址到購物網站，<br>
                避免日後寄錯地址即可，謝謝
              </div>

              <div
                v-if="whs"
                class="grey--text py-2 px-4 mt-2 addrWrap"
              >
                收件人：{{ whs.formatAddr.name }} <br>
                電話： {{ whs.formatAddr.phone }}<br>
                郵編： {{ whs.formatAddr.postcode }}<br>
                <v-layout class="ma-0">
                  <div style="word-break: keep-all;">
                    地址：
                  </div>
                  <v-flex class="pa-0">
                    {{ whs.formatAddr.addr }}
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>

          <div
            class="mt-4"
            style="padding:0 50px;"
          >
            <v-btn
              v-if="installedCrx"
              :loading="loading === 'taobao'"
              block
              large
              color="#f63b00"
              class="white--text  my-2"
              @click.stop="toTaobao('taobao')"
            >
              <i
                class="iconfont icontaobao mr-1"
                style="font-size: 22px;line-height: 18px;"
              />
              設置到淘寶
            </v-btn>

            <v-btn
              v-if="installedCrx"
              :loading="loading === '1688'"
              block
              large
              color="#f75900"
              class="white--text my-2"
              @click.stop="toTaobao('1688')"
            >
              <i
                class="iconfont iconalibaba"
                style="font-size: 28px;line-height: 18px;"
              />
              設置到阿里巴巴
            </v-btn>

            <v-btn
              block
              large
              color="info"
              class="my-2"
              @click.stop="showFixOtherDialog=true"
            >
              <v-icon class="mr-1">
                image
              </v-icon>
              其他平台集運倉地址手動修正
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <template v-else>
        <v-card>
          <div class="title red--text text-xs-center pt-4">
            {{ accountRestrictionTitle }}
          </div>
          <v-card-text
            v-if="!user.nickname"
          >
            <h4 class="red--text">
              轉運倉收件人升級為暱稱，會員之間暱稱不可重複，暱稱可以不是真實姓名。
            </h4>
            <v-form
              ref="form"
            >
              <v-text-field
                v-model="nicknameInputVaue"
                :rules="[$store.state.validationRules.required, $store.state.validationRules.nickname]"
                label=" 請輸入2-5位中文暱稱"
                required
                class="my-2"
              />

              <v-layout>
                <v-spacer />
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="info"
                  @click="saveNickname"
                >
                  送出
                </v-btn>
              </v-layout>
            </v-form>
          </v-card-text>

          <template v-else-if="resetInfo">
            <v-card-text class="dialog-conente-scroll pb-2">
              <template v-if="step === 1">
                <div class="mb-2 blue--text">
                  <div class="subTitle">
                    限制原因
                  </div>
                  <div class="ml-2">
                    您的倉庫收件資料有誤，修正後就可以繼續使用
                  </div>
                </div>
                <!-- <v-alert
                :value="true"
                color="error"
                class="subheading"
              >
                您的收件地址存在以下錯誤：
                <div
                  v-for="(error,i) in resetInfo.errors"
                  :key="error">
                  {{ i+1 }}、{{ error | whsAddrResetErrorText }}
                </div>
              </v-alert> -->

                <div
                  v-if="resetInfo.parcelEs"
                >
                  <v-img
                    :src="resetInfo.parcelEs | upyun"
                    aspect-ratio="1.7"
                    @click.native="openPhotoSwipe([resetInfo.parcelEs])"
                  />
                </div>
                <v-btn
                  block
                  color="info"
                  class="mt-4"
                  @click="step = 2"
                >
                  解除限制
                </v-btn>
              </template>
              <template v-else-if="step === 2">
                <div class="blue--text">
                  <div class="subTitle">
                    解除辦法
                  </div>
                  <div class="ml-2">
                    淘寶及阿里巴巴平台請點擊下方按鈕將倉庫地址導入，即可恢復帳號。
                  </div>
                </div>

                <div
                  v-if="!installedCrx"
                  class="grey lighten-4 pa-2 mt-4"
                >
                  安裝
                  <a
                    class="down-link"
                    href="https://chrome.google.com/webstore/detail/%E5%B7%A7%E5%B7%A7%E9%83%8E%E5%8C%85%E8%A3%B9%E7%AE%A1%E5%AE%B6/lacejchmbljdoaimkbmcflcechgndbim"
                    target="_blank"
                  >巧巧郎的鑰匙</a>
                  ，地址自動key入到淘寶。
                </div>
                <template v-else>
                  <v-btn
                    v-if="installedCrx"
                    :loading="loading === 'taobao'"
                    block
                    large
                    color="#f63b00"
                    class="white--text  my-2"
                    @click.stop="toTaobao('taobao')"
                  >
                    <i
                      class="iconfont icontaobao mr-1"
                      style="font-size: 22px;line-height: 18px;"
                    />
                    設置到淘寶
                  </v-btn>

                  <v-btn
                    v-if="installedCrx"
                    :loading="loading === '1688'"
                    block
                    large
                    color="#f75900"
                    class="white--text my-2"
                    @click.stop="toTaobao('1688')"
                  >
                    <i
                      class="iconfont iconalibaba"
                      style="font-size: 28px;line-height: 18px;"
                    />
                    設置到阿里巴巴
                  </v-btn>
                  <div class="blue--text mt-4">
                    其他購物平台請點擊下方按鈕修正。
                  </div>

                  <v-btn
                    block
                    large
                    color="info"
                    class="my-2"
                    @click.stop="showFixOtherDialog=true"
                  >
                    <v-icon class="mr-1">
                      image
                    </v-icon>
                    其他平台集運倉地址手動修正
                  </v-btn>
                </template>
              </template>
            </v-card-text>
          </template>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="showFixOtherDialog"
      width="450"
    >
      <v-card>
        <v-toolbar
          dark
          dense
          color="blue darken-1"
        >
          <v-toolbar-title>
            其他平台手動修正
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="showFixOtherDialog=false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="showFixOtherDialog && whs && resetInfo">
          <div
            v-if="whs && !isUpdateAddr"
            class="grey lighten-4 pa-2"
          >
            <div class="subTitle mb-1">
              請手動修正集運倉地址中的：
            </div>
            <div class="pl-2">
              <div v-if="resetInfo.errors.includes('e1') || resetInfo.errors.includes('e2')">
                <span class="grey--text">收件人：</span>{{ whs.formatAddr.name }}<v-btn
                  small
                  flat
                  icon
                  color="info"
                  class="ma-0"
                  @click="copyText(whs.formatAddr.name)"
                >
                  <i class="iconfont iconfuzhi" />
                </v-btn>
              </div>
              <v-layout
                v-if="resetInfo.errors.includes('e3')"
                class="ma-0"
              >
                <div
                  style="word-break: keep-all;"
                  class="grey--text"
                >
                  地址：
                </div>
                <v-flex class="pa-0">
                  {{ whs.formatAddr.addr }}<v-btn
                    small
                    flat
                    icon
                    color="info"
                    class="ma-0"
                    @click="copyText(whs.formatAddr.addr)"
                  >
                    <i class="iconfont iconfuzhi" />
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
          <div class="py-2 mt-2">
            <div>
              上傳修改後的頁面截圖
            </div>
            <div class="px-4 mt-3">
              <UploadImage
                v-model="fixOtherForm.snapshoot"
                single
                dir="syncwhs"
                class="mx-4"
              />
            </div>
          </div>
          <div class="grey--text mt-2">
            *您需提供修改後的收貨地址頁面截圖，客服完成審核後即可恢復帳號
          </div>
          <v-btn
            :loading="submitOtherSnapshootLoading"
            color="info"
            block
            large
            class="mt-4"
            @click="submitOtherSnapshoot"
          >
            提交審核
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { copyText } from '@g/utils'
import { setAddr } from '@/utils/crxSDK'
import UploadImage from '@/components/UploadImage'
import eventBus, { eventType } from '@g/utils/eventBus'

export default {
  components: {
    UploadImage,
  },
  props: {
    small: Boolean,
  },
  data () {
    return {
      installedCrx: false,
      loading: false,
      nicknameInputVaue: '',

      showUpdagteAddrDialog: false,
      resetInfo: null,

      showFixOtherDialog: false,
      submitOtherSnapshootLoading: false,
      fixOtherForm: {
        snapshoot: [],
      },
      step: 1,
    }
  },
  computed: {
    user () {
      // return {
      //   uid: '222',
      //   realname: '',
      //   nickname: 'test',
      //   syncWhsAddrids: '',
      // }
      return this.$store.state.userData
    },
    isChrome () {
      return this.$store.state.isChrome
    },
    accountRestrictionTitle () {
      const brandName = ['mgb-pc', 'mgb-h5'].includes(this.$store.state.project) ? '買即可' : '巧巧郎'
      return `您的${brandName}帳戶暫時限制使用`
    },
    whs () {
      if (this.isUpdateAddr) {
        const addrid = this.resetInfo.errors.find(err => err.indexOf('e4') > -1).split('-')[1]

        return this.$store.state.jyWarehouses.find(addr => this.resetInfo && addr.addrid === addrid)
      }
      return this.$store.state.jyWarehouses.find(addr => this.resetInfo && addr.addrid === this.resetInfo.addrid)
    },
    isUpdateAddr () {
      return this.resetInfo && !!this.resetInfo.errors.find(err => err.indexOf('e4') > -1)
    },
  },
  watch: {
    user: {
      immediate: true,
      handler () {
        this.showUpdagteAddrDialog = false
        if (this.user.syncWhsAddrids && this.user.syncWhsAddrids.resets && this.user.syncWhsAddrids.resets.find) {
          const resetInfo = this.user.syncWhsAddrids.resets.find(reset => reset.error)
          if (resetInfo && resetInfo.addrid > 0) {
            this.resetInfo = {
              ...resetInfo,
              errors: resetInfo.error.split(',')
            }
            console.log('resetInfo', this.resetInfo)
            this.step = 1
            this.showUpdagteAddrDialog = true
          }
        }
        if (!this.showUpdagteAddrDialog) {
          this.showFixOtherDialog = false
        }
        // // 判斷 stepName 防止跟新手引導衝突，hasParcel 有导入过商品才需要修改
        // if (this.user.hasParcel && this.user.uid) {
        //   const syncWhsAddrids = this.user.syncWhsAddrids || {}
        //   // if (
        //   //   (!syncWhsAddrids.taobao || !syncWhsAddrids.taobao.includes(this.whsItem.addrid)) &&
        //   //   (!syncWhsAddrids['1688'] || !syncWhsAddrids['1688'].includes(this.whsItem.addrid))
        //   // ) {
        //   if (!this.user.nickname || !this.user.syncWhsAddrids || this.user.syncWhsAddrids.length === 0) {
        //     this.showUpdagteAddrDialog = true
        //   }
        //   // }
        // }
      }
    },
  },
  mounted () {
    console.log('this.isChrome', this.isChrome)
    if (this.isChrome) {
      this.checkInstallCrx()
      this.checkTimer = setInterval(async () => {
        this.checkInstallCrx()
      }, 5000)
    }
  },
  beforeDestroy () {
  },
  methods: {
    copyText (text) {
      copyText(text)
      this.$snackbar('複製成功')
    },
    openPhotoSwipe (snapshots) {
      if (!snapshots || !snapshots.length) {
        return
      }
      eventBus.$emit(eventType.ViewImages, snapshots)
    },
    async checkInstallCrx () {
      if (await this.$store.dispatch('checkInstallCrx')) {
        this.installedCrx = true
        clearInterval(this.checkTimer)
      }
    },
    async toTaobao (type) {
      try {
        this.loading = type
        const r = await setAddr(type)
        this.$store.dispatch('init')

        if (this.showUpdagteAddrDialog) {
          if (await this.$confirm('設置成功', { buttonFalseText: '' })) {
            this.showUpdagteAddrDialog = false
          }
        } else {
          this.$emit('addAddressSuccess', { platform: r.type })
          this.$snackbar('設置成功', {
            color: 'success',
          })
        }
      } finally {
        this.loading = false
      }
    },
    async saveNickname () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.loading = true
        if (!await this.$confirm('暱稱設定後將無法修改', {
          buttonTrueText: '確認',
          buttonFalseText: '取消',
        })) return
        const res = await this.$store.dispatch('user/updateNickname', {
          newNickname: this.nicknameInputVaue
        })
        if (!res.data.error) {
          this.$store.state.userData.nickname = res.data.model.nickname
        }
      } finally {
        this.loading = false
      }
    },
    async submitOtherSnapshoot () {
      try {
        this.submitOtherSnapshootLoading = true
        const res = await this.$store.dispatch('user/usermbr/updateSyncWhsAddrids', {
          params: {
            reset: {
              addrid: this.resetInfo.addrid,
              platform: 'any',
              error: '',
              snapshoot: this.fixOtherForm.snapshoot.map(item => item.url)[0],
            }
          },
          options: {
            noShowError: true,
          }
        })
        if (!res.data.error) {
          await this.$store.dispatch('init')
        } else {
          this.$confirm(res.data.message.replaceAll('、', '<br/>'), {
            buttonFalseText: false,
            width: '480'
          })
        }
      } finally {
        this.submitOtherSnapshootLoading = false
      }
    },
  }
}
</script>
<style lang="postcss" scoped>
.addrWrap {
  border: 2px dashed currentColor;
}
</style>
